export const ResponsiveBreakpoints = {
  Mini: "(min-width:321px)",
  Container: "(min-width:500px)",
  Mobile: "(min-width:640px)",
  Tablet: "(min-width:768px)",
  Desktop: "(min-width:1024px)",
};

export enum Breakpoint {
  Mini = 321,
  Container = 500,
  Mobile = 640,
  Tablet = 768,
  Desktop = 1024,
}